module.exports = __webpack_public_path__ + "svg/flags/Isle of Man.svg";